import Spinner from './Spinner';
import initTableBars from './tableBars';
import initWeeklyBars from './weeklyBars';
import initFilters from './filter';

const PERIOD_CONVERTER = {
  '7 d': 7,
  '14 d': 14,
  '30 d': 30,
  '365 d': 365,
  'All time': 0,
};

const rerenderThreats = (() => {
  let previousQuery = {
    search: '',
    period: '',
    country: '',
    type: '',
    title: '',
  };

  return async () => {
    const searchValue = $('#search').val().trim();
    const searchQuery = searchValue ? `/search/${searchValue}` : '';

    const activePeriod = $('#period').val();
    const period = `/period/${PERIOD_CONVERTER[activePeriod]}`;

    const countriesArray = $('input[name="country"]:checked').map(function () {
      return $(this).val();
    }).toArray();
    const countriesQuery = countriesArray.length ? `/country/${countriesArray.join('&')}` : '';

    const typesArray = $('input[name="type"]:checked').map(function () {
      return $(this).val();
    }).toArray();
    const typesQuery = typesArray.length ? `/type/${typesArray.join('&')}` : '';

    const titlesArray = $('input[name="title"]:checked').map(function () {
      return $(this).val();
    }).toArray();
    const titlesQuery = titlesArray.length ? `/title/${titlesArray.join('&')}` : '';

    const searchHasNotChanged = previousQuery.search === searchValue;
    const periodHasNotChanged = previousQuery.period === period;
    const countryHasNotChange = previousQuery.country === countriesQuery;
    const typeHasNotChange = previousQuery.type === typesQuery;
    const titleHasNotChange = previousQuery.title === titlesQuery;

    if (searchHasNotChanged
      && periodHasNotChanged
      && countryHasNotChange
      && typeHasNotChange
      && titleHasNotChange) {
      return;
    }

    previousQuery = {
      search: searchValue,
      period,
      country: countriesQuery,
      type: typesQuery,
      title: titlesQuery,
    };

    Spinner.show();

    const url = `/malware-trends${searchQuery}${countriesQuery}${typesQuery}${titlesQuery}${period}`;
    const response = await fetch(url, { method: 'GET' });

    if (response.ok) {
      const json = await response.json();
      const $threats = $('#threats');

      Spinner.clearAndAppend($threats, json.html);
      initWeeklyBars();
      initTableBars();
      initFilters();

      return;
    }

    throw Error(`Error HTTP: ${response.status}`);
  };
})();

export default rerenderThreats;
